import { PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from '@env/environment';
import { AcRoutingService } from '@core/services/routing/ac-routing.service';

export const enum AuthConfigIds {
  AZURE = 'azure',
  ONE_LOGIN = 'oneLogin',
}

export const authConfig: PassedInitialConfig = {
  config: [
    {
      configId: AuthConfigIds.ONE_LOGIN,
      authority: environment.oneLoginIssuer,
      redirectUrl: environment.oidcRedirect,
      postLogoutRedirectUri: environment.oidcRedirect,
      clientId: environment.oneLoginClientId,
      scope: environment.oidcScope,
      maxIdTokenIatOffsetAllowedInSeconds: 240,
      responseType: 'code',
      autoUserInfo: true,
      renewUserInfoAfterTokenRenew: true,
      ignoreNonceAfterRefresh: true,
      customParamsAuthRequest: {
        resource: environment.baseUrl,
      },
      unauthorizedRoute: AcRoutingService.UNAUTHORIZED_ROUTE().join(),
    },
    {
      configId: AuthConfigIds.AZURE,
      authority: environment.azureIssuer,
      redirectUrl: environment.oidcRedirect,
      postLogoutRedirectUri: environment.oidcRedirect,
      clientId: environment.azureClientId,
      scope: environment.oidcScope,
      responseType: 'code',
      silentRenew: true,
      useRefreshToken: true,
      ignoreNonceAfterRefresh: true,
      maxIdTokenIatOffsetAllowedInSeconds: 600,
      autoUserInfo: false,
      renewUserInfoAfterTokenRenew: true,
      unauthorizedRoute: AcRoutingService.UNAUTHORIZED_ROUTE().join(),
    },
  ],
};
